export default __webpack_public_path__ + "static/media/banner1.95dbf315.svg";